import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom"; // Import Link for navigation

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 text-white py-24 sm:py-32">
      <div className="absolute inset-0 bg-black opacity-20"></div>

      <div className="max-w-screen-xl mx-auto px-6 sm:px-8 relative z-10">
        <div className="text-center">
         
          <motion.h1
            className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-shadow-md mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, type: "spring", stiffness: 80 }}
          >
            Transform Your Images for Faster Web Performance
          </motion.h1>

        
          <motion.p
            className="text-lg sm:text-xl md:text-2xl mb-10 max-w-2xl mx-auto opacity-90"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, type: "spring", stiffness: 80 }}
          >
            Convert images to optimized formats in seconds and speed up your
            website with high-quality, lightweight images.
          </motion.p>

    
          <a href="#upload" className="inline-block bg-yellow-500 text-white hover:bg-yellow-600 px-8 py-4 rounded-xl text-lg font-semibold shadow-xl transform transition duration-300 hover:scale-105">
            Get Started
          </a>
        </div>

        {/* Animated Background Circles */}
        <div className="absolute inset-0 flex items-center justify-center opacity-20 pointer-events-none">
          <motion.svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-full"
            viewBox="0 0 400 400"
            fill="none"
          >
            <motion.circle
              cx="50%"
              cy="50%"
              r="10%"
              stroke="white"
              strokeWidth="1"
              animate={{ r: ["10%", "25%", "10%"] }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
            <motion.circle
              cx="25%"
              cy="25%"
              r="5%"
              stroke="white"
              strokeWidth="1"
              animate={{ r: ["5%", "15%", "5%"] }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
            <motion.circle
              cx="75%"
              cy="75%"
              r="5%"
              stroke="white"
              strokeWidth="1"
              animate={{ r: ["5%", "15%", "5%"] }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
          </motion.svg>
        </div>
      </div>

      {/* Animated Trusted Text */}
      <motion.div
        className="text-center mt-16"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="text-lg sm:text-xl text-white opacity-80">
          Trusted by hundreds worldwide!
        </p>
      </motion.div>
    </section>
  );
};

export default HeroSection;
